import instance, { ADMIN_PREFIX } from 'services/api';

export interface TagRow {
  id: number;
  name: string;
  lang: string;
  sortIndex: number | null;
}

export interface TagsListResponse {
  data: TagRow[];
  total: number;
}

export interface CreateTagInput {
  name: string;
  lang?: string;
  sortIndex?: number;
}

// Generous ceiling for the multi-select dropdown — the legacy GQL
// returned the full list, and PaginatedResponse defaults to 20.
export const TAGS_FETCH_LIMIT = 1000;

export const fetchTags = (lang: string, limit = TAGS_FETCH_LIMIT) =>
  instance.get<TagsListResponse>(`${ADMIN_PREFIX}/content/tags`, {
    params: { limit },
    headers: { locale: lang }
  });

export const createTag = (input: CreateTagInput) =>
  instance.post<TagRow>(`${ADMIN_PREFIX}/content/tags`, input);

export const attachTagsToDoctor = (doctorId: number, tagIds: number[]) =>
  instance.post(`${ADMIN_PREFIX}/tags/attach/doctor`, {
    doctor_id: doctorId,
    tag_ids: tagIds
  });

export const detachTagsFromDoctor = (doctorId: number, tagIds: number[]) =>
  instance.delete(`${ADMIN_PREFIX}/tags/detach/doctor/${doctorId}`, {
    params: { tag_ids: tagIds }
  });
